import React, { CSSProperties, FC } from 'react';
import { IProps } from 'src/types/layout.types';
import styles from './title-box.module.less';
export type BoxProps = IProps & {
	style?: CSSProperties;
	className?: string;
};
const TitleBox: FC<BoxProps> = ({ children, style, className }) => {
	return (
		<div className={`${styles.box} ${className}`} style={style}>
			{children}
		</div>
	);
};
export default TitleBox;
